<template>
  <div>
    <v-row class="ml-1 mt-2">
      <strong class="mt-2 mr-2">文法名</strong>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{
        $t("SEARCH")
      }}</v-btn>

      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <!-- add item for grammar-->
      <v-btn
        :to="{ name: 'Grammar Create Of Self Study' }"
        class="ml-2"
        color="primary"
        >新規登録</v-btn
      >
    </v-row>
    <v-layout child-flex class="ml-1">
      <v-data-iterator
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        :items="listGrammar"
        :loading="loadingListGrammar"
        :key="keyListGrammar"
        hide-default-footer
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="(item, index) in props.items"
              :key="index"
              cols="2"
              class="card-list"
            >
              <v-card color="#f5f5f5">
                <v-card-text class="align-start pb-2">
                  <span class="font-weight-bold">
                    <template v-for="field in item.data">
                      <v-tooltip
                        top
                        :key="field.id"
                        v-if="field.key == 'Title'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <template class="d-inline-block text-truncate mt-1">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              class="d-inline-block text-truncate px-2"
                              style="max-width: 180px"
                              >{{ field.value.ja }}</span
                            >
                          </template>
                        </template>
                        <span
                          class="px-2"
                          style="max-width: 130px"
                          v-text="field.value.ja"
                        />
                      </v-tooltip>
                    </template>
                  </span>
                  <div class="row pa-0 ma-0">
                    <div class="icon-trash">
                      <v-icon small class="mr-2" @click="viewDetail(item)"
                        >fas fa-pencil-alt</v-icon
                      >
                      <!-- delete item grammar -->
                      <DeleteItemGrammar
                        :item="item"
                        @resetList="handleGetListGrammar"
                      />
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-slot:loading>
          <div class="text-center mt-5">読み込み中。。。待ってください。</div>
        </template>
        <template v-slot:no-data>
          <div class="text-center mt-5">データがありません。</div>
        </template>
      </v-data-iterator>
    </v-layout>
    <BasePagination
      v-if="listGrammar.length > 0"
      :pageCount="listGrammar.length"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import DeleteItemGrammar from "@/views/grammar/DeleteItemGrammar.vue";
import BasePagination from "@/components/Pagination/BasePagination";
import { getListGrammar } from "@/api/Grammar.api";
export default {
  mixins: [mixin.App, mixin.DetailGrammar],
  components: {
    BasePagination,
    DeleteItemGrammar,
  },
  data() {
    return {
      keyword: "",
      listGrammar: [],
      defaultListGrammar: [],
      keyListGrammar: 0,
      loadingListGrammar: false,
    };
  },
  async created() {
    await this.handleGetListGrammar();
  },
  methods: {
    async handleGetListGrammar() {
      this.keyListGrammar++;
      let params = {
        keyword: "",
        sub_key: "",
      };
      this.loadingListGrammar = true;
      await getListGrammar(params)
        .then((data) => {
          this.defaultListGrammar = data.result;
          this.listGrammar = data.result;
          this.pagination.pageCount = data.totalCount;
          this.loadingListGrammar = false;
        })
        .catch((error) => {
          this.loadingListGrammar = false;
          console.log(error);
        });
    },
    async search() {
      await this.handleGetListGrammar();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listGrammar = this.defaultListGrammar.filter((item) =>
        item.data.find(
          (i) =>
            i.key == "Title" &&
            i.value.ja.toLowerCase().search(keywordSearch) > -1
        )
      );
      this.pagination.pageCount = this.listGrammar.length;
    },
    changePage(value) {
      this.pagination.page = value;
    },
    async viewDetail(value) {
      this.$router.push({
        name: "Grammar Update Of Self Study",
        params: { grammar: value.Id },
      });
    },
    async resetList() {
      await this.handleGetListGrammar();
      this.pagination.page = 1;
    },
  },
};
</script>